module.exports = __webpack_public_path__ + "img/bg.d99945f3.jpg";